export const sophieSkincareProfile = {
  user: {
    user: { email: '', first_name: 'Sophie' },
    profile: {
      profile_id: 'ec126117-c908-4371-be3e-d1a402c0ecd1',
      predefined: true,
      profile_img_url: '/static/sophie-profile-image.png',
      job_title: 'Graphic Designer',
    },
    basic_info: {
      gender: '1',
      birth_year: 1982,
      city: 'Queens',
      state: 'NY',
      country: 'USA',
    },
    lifestyle: [
      { name: 'Vegetarian', unique_code: 'vegetarian', type: 'DIET' },
      { name: 'Surfer', unique_code: 'surfer', type: 'HABITS' },
      { name: 'Active', unique_code: 'active', type: 'ENVIRONMENT' },
      { name: 'Urban', unique_code: 'urban', type: 'ACTIVITY LEVEL' },
    ],
    dna_results: [
      {
        trait: { name: 'Luthein and Zeaxanthin' },
        trait_risk_level: 2,
        no_genetic_variants: 2,
        population_percentage: 65,
      },
      {
        trait: { name: 'Magnesium Deficiency' },
        trait_risk_level: 2,
        no_genetic_variants: 5,
        population_percentage: 75,
      },
      {
        trait: { name: 'Vitamin E Deficiency' },
        trait_risk_level: 1,
        no_genetic_variants: 2,
        population_percentage: 75,
      },
      {
        trait: { name: 'Protein Intake Need' },
        trait_risk_level: 1,
        no_genetic_variants: 4,
        population_percentage: 85,
      },
      {
        trait: { name: 'Vitamin A Deficiency' },
        trait_risk_level: 1,
        no_genetic_variants: 3,
        population_percentage: 95,
      },
      {
        trait: { name: 'Skin Glycation' },
        trait_risk_level: 4,
        no_genetic_variants: 1,
        population_percentage: 25,
      },
      {
        trait: { name: 'Skin Aging' },
        trait_risk_level: 2,
        no_genetic_variants: 5,
        population_percentage: 60,
      },
      {
        trait: { name: 'Sunburn Potential' },
        trait_risk_level: 1,
        no_genetic_variants: 7,
        population_percentage: 75,
      },
      {
        trait: { name: 'UV Sensitivity' },
        trait_risk_level: 1,
        no_genetic_variants: 7,
        population_percentage: 75,
      },
      {
        trait: { name: 'Skin Dryness' },
        trait_risk_level: 0,
        no_genetic_variants: 12,
        population_percentage: 90,
      },
    ],
  },
  category: { name: 'Skin Care', unique_code: 'skin_care', enabled: true },
  categoriesExplanations: [
    {
      text:
        '<span>An individual’s dietary choices and restrictions impact their nutrition outcomes as well as optimal nutrition related recommendations. Sophie’s low-fat, vitamin-incomplete diet impacts the types of dietary recommendations she will receive and her overall nutritional health.</span> <br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s diet, and accurately personalizes her product recommendation to include products with key nutrients that meet her unique nutrition needs.</span>',
      lifestyle: {
        name: 'Vegetarian',
        unique_code: 'vegetarian',
        type: 'DIET',
      },
      category: {
        name: 'Diet & Nutrition',
        unique_code: 'nutrition',
        enabled: true,
      },
    },
    {
      text:
        '<span>An individual’s exposure to UV while performing outdoor activities can impact their skin health. Sophie’s surfing habit can lead to UV exposure both directly from the sun as well as from rays reflecting from the water and can seriously impact their skin health and risk of developing skin care related diseases in the long run.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s athletic habits, and accurately personalizes her product recommendation to include products with ingredients that meet her unique skin care needs.</span>',
      lifestyle: { name: 'Surfer', unique_code: 'surfer', type: 'HABITS' },
      category: {
        name: 'Diet & Nutrition',
        unique_code: 'nutrition',
        enabled: true,
      },
    },
    {
      text:
        '<span>An individual’s lifestyle and activity levels impacts their nutritional needs. Sophie’s semi active lifestyle can impact the optimal macro and micro nutrient ratios as well as her daily caloric intake.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s activity levels, and accurately personalizes her product recommendation to include products with ingredients that meet her unique nutritional needs.</span>',
      lifestyle: { name: 'Active', unique_code: 'active', type: 'ENVIRONMENT' },
      category: {
        name: 'Diet & Nutrition',
        unique_code: 'nutrition',
        enabled: true,
      },
    },
    {
      text:
        '<span>An individual’s environment can impact their optimal nutritional recommendations. Sophie’s location will impact her nutritional needs as it relates to consuming foods that reduce inflammation or counteract the other carcinogens in her environment.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s environmental context, and accurately personalizes her product recommendation to include products with ingredients that meet her unique nutritional needs.</span>',
      lifestyle: {
        name: 'Urban',
        unique_code: 'urban',
        type: 'ACTIVITY LEVEL',
      },
      category: {
        name: 'Diet & Nutrition',
        unique_code: 'nutrition',
        enabled: true,
      },
    },
    {
      text:
        '<span>An individual’s diet impacts their skin health. Sophie’s <span className="bold">low-fat, vitamin-incomplete diet</span> can have an adverse effect on her <span className="bold">skin health</span> and <span className="bold">acne</span>.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s diet, and accurately personalizes her product recommendation to include products with ingredients that meet her unique skin care needs.</span>',
      lifestyle: {
        name: 'Vegetarian',
        unique_code: 'vegetarian',
        type: 'DIET',
      },
      category: { name: 'Skin Care', unique_code: 'skin_care', enabled: true },
    },
    {
      text:
        '<span>An individual’s exposure to UV while performing outdoor activities can impact their skin health. Sophie’s surfing habit can lead to UV exposure both directly from the sun as well as from rays reflecting from the water and can seriously impact their skin health and risk of developing skin care related diseases in the long run.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s athletic habits, and accurately personalizes her product recommendation to include products with ingredients that meet her unique skin care needs.</span>',
      lifestyle: { name: 'Surfer', unique_code: 'surfer', type: 'HABITS' },
      category: { name: 'Skin Care', unique_code: 'skin_care', enabled: true },
    },
    {
      text:
        '<span>An individual’s lifestyle and activity levels can impact their skin care. Sophie’s semi <span className="bold">active</span> lifestyle can impact her <span className="bold">hormone levels and circulation</span>, both of which impact her skin health.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s activity levels, and accurately personalizes her product recommendation to include products with ingredients that meet her unique skin care needs.</span>',
      lifestyle: { name: 'Active', unique_code: 'active', type: 'ENVIRONMENT' },
      category: { name: 'Skin Care', unique_code: 'skin_care', enabled: true },
    },
    {
      text:
        '<span>An individual’s environment can greatly impact their skin health. Sophie’s location will impact her skin health due to variables such as <span className="bold">daily UV exposure</span> as well as <span className="bold">air pollution levels</span>.</span><br /><br /><span>The <span className="bold">Precision Consumption Marketplace’s</span> AI technology assesses Sophie’s environmental context, and accurately personalizes her product recommendation to include products with ingredients that meet her unique skin care needs.</span>',
      lifestyle: {
        name: 'Urban',
        unique_code: 'urban',
        type: 'ACTIVITY LEVEL',
      },
      category: { name: 'Skin Care', unique_code: 'skin_care', enabled: true },
    },
  ],
  price: 0,
  selectedBrands: [
    { unique_code: 'AllBrands', name: 'All Brands' },
    { name: 'Clinique', unique_code: 'Clinique' },
    { name: 'Neutrogena', unique_code: 'Neutrogena' },
    { name: "Pond's", unique_code: 'Ponds' },
    { name: 'Olay', unique_code: 'Olay' },
  ],
  retailerImage: 'retailer_a.png',
};
